import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import store from 'store'
import GlobalStyles from 'styles/GlobalStyles'
import AppRoutes from 'routes'
import { AlertPopupsProvider } from 'context/AlertPopups'
import {
  WarningPopup,
  ConfirmationPopup,
  ErrorPopup
} from 'components/AlertPopups'
// import WelcomePopup from 'components/WelcomePopup'
import ApiErrorPopup from 'components/ApiErrorPopup'
import FullStoragePopup from 'components/FullStoragePopup'
import NotificationCenter from 'components/NotificationCenter'
import { getBasename } from 'utils/routing'
import { TimelineContextProvider } from 'context/TimelineContext'
import { WebWoodContextProvider } from 'context/WebWoodContext'
import { PowerModeRequiredPopup } from 'components/PowerModeRequiredPopup'
import { PowerModeRetryContextProvider } from 'context/PowerModeRetryContext'
import { ReportedIssue } from 'utils/errors'
import { captureError } from 'utils/captureError'

const App: React.FC = () => {
  const basename = getBasename()

  useEffect(() => {
    window.reportIssue = (message: string) => {
      const error = new ReportedIssue(message)
      captureError(error)
    }
  }, [])

  return (
    <Provider store={store}>
      <BrowserRouter basename={basename}>
        <AlertPopupsProvider>
          <TimelineContextProvider>
            <WebWoodContextProvider>
              <PowerModeRetryContextProvider>
                <GlobalStyles />
                <AppRoutes />
                <PowerModeRequiredPopup />
              </PowerModeRetryContextProvider>
            </WebWoodContextProvider>
          </TimelineContextProvider>
          <WarningPopup />
          <ErrorPopup />
          <ConfirmationPopup />
          {/* <WelcomePopup /> */}
          <ApiErrorPopup />
          <FullStoragePopup />
          <NotificationCenter />
        </AlertPopupsProvider>
      </BrowserRouter>
    </Provider>
  )
}

export default App
